var React = require('react');

function CateringDelivery (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M23.4,46.2v10.8l8.1,21.6h37.7l8.1-21.6v-10.8H23.4ZM61.8,67.7h-22.8l-4-10.8h30.9l-4,10.8Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M69.2,40.8c0-8.4-4.1-16-10.8-21.6,0,6-4.8,10.8-10.8,10.8h-5.4c-6,0-10.8,4.8-10.8,10.8h37.7Z","key":2})]);
}

CateringDelivery.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 100 100","width":"100","height":"100"};

module.exports = CateringDelivery;

CateringDelivery.default = CateringDelivery;
